/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CouponState } from "./CouponState";
import {
  CouponStateFromJSON,
  CouponStateFromJSONTyped,
  CouponStateToJSON,
  CouponStateToJSONTyped,
} from "./CouponState";

/**
 *
 * @export
 * @interface Coupon
 */
export interface Coupon {
  /**
   *
   * @type {string}
   * @memberof Coupon
   */
  couponId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Coupon
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Coupon
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof Coupon
   */
  companyId?: string;
  /**
   *
   * @type {number}
   * @memberof Coupon
   */
  amount?: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Coupon
   */
  expires?: OffsetDateTime;
  /**
   *
   * @type {CouponState}
   * @memberof Coupon
   */
  couponState?: CouponState;
  /**
   *
   * @type {string}
   * @memberof Coupon
   */
  shipmentId?: string;
  /**
   *
   * @type {string}
   * @memberof Coupon
   */
  referringCompanyId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Coupon
   */
  usedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Coupon
   */
  purpose?: string;
}

/**
 * Check if a given object implements the Coupon interface.
 */
export function instanceOfCoupon(value: object): value is Coupon {
  return true;
}

export function CouponFromJSON(json: any): Coupon {
  return CouponFromJSONTyped(json, false);
}

export function CouponFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Coupon {
  if (json == null) {
    return json;
  }
  return {
    couponId: json["couponId"] == null ? undefined : json["couponId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    amount: json["amount"] == null ? undefined : json["amount"],
    expires: json["expires"] == null ? undefined : json["expires"],
    couponState:
      json["couponState"] == null
        ? undefined
        : CouponStateFromJSON(json["couponState"]),
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    referringCompanyId:
      json["referringCompanyId"] == null
        ? undefined
        : json["referringCompanyId"],
    usedAt: json["usedAt"] == null ? undefined : json["usedAt"],
    purpose: json["purpose"] == null ? undefined : json["purpose"],
  };
}

export function CouponToJSON(json: any): Coupon {
  return CouponToJSONTyped(json, false);
}

export function CouponToJSONTyped(
  value?: Coupon | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    couponId: value["couponId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    companyId: value["companyId"],
    amount: value["amount"],
    expires: value["expires"],
    couponState: CouponStateToJSON(value["couponState"]),
    shipmentId: value["shipmentId"],
    referringCompanyId: value["referringCompanyId"],
    usedAt: value["usedAt"],
    purpose: value["purpose"],
  };
}
